import { CreditCard as CreditCardIcon } from 'react-feather';

export default function BlueCardIcon({ style }: { style?: { [key: string]: string } }) {
  return (
    <CreditCardIcon
      style={{
        color: '#0032C8', //'#0AF',
        backgroundColor: 'rgba(149, 173, 253, 0.2)',
        width: '2.5em',
        height: '2.5em',
        padding: '0.6em',
        borderRadius: '5px',
        ...style,
      }}
    />
  );
}
